import { sendPost } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const login = (payload: any) => sendPost('/auth/login', payload);
export const signUp = (payload: any) => sendPost('/auth/register', payload);
export const checkEmail = (payload: any) => sendPost('/auth/check-email-existed', payload);
export const requestVerifyCode = (payload: any) => sendPost('/auth/request-verified-code', payload);
export const checkVerifyCode = (payload: any) => sendPost('/auth/check-verified-code', payload);
export const forgotPassword = (payload: any) => sendPost('/auth/forgot-password', payload);
export const resetPassword = (payload: any) => sendPost('/auth/reset-password', payload);
export const cancelSubscription = () => sendPost(`/auth/cancel-subscription`)
export const uploadImage = (payload: any) => sendPost('/upload', payload);
